import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyCfMj2gIeo5DVLRdbbzHFKmihnLbGLFEYM",
  authDomain: "tifoo-4bdc6.firebaseapp.com",
  databaseURL: "https://tifoo-4bdc6-default-rtdb.firebaseio.com",
  projectId: "tifoo-4bdc6",
  storageBucket: "tifoo-4bdc6.firebasestorage.app",
  messagingSenderId: "304522889506",
  appId: "1:304522889506:web:1f88b2d08fa1cd773cfd7b",
  measurementId: "G-JYL3XGKQ01"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const analytics = getAnalytics(app);

export { auth, db, storage };